export default "__VITE_ASSET__Dj3e5VRG__"